import { selectedAttributes } from '@/constants/selectedAttributes';
import axios from '../axios-config';

const getProductBySku = async (sku, getFullResponnse = true) => {
  const config = {
    method: 'get',
    url: `/search/product/${sku}`,
  };
  if (!getFullResponnse) {
    config.url += `?${selectedAttributes}`;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductBySkuV2 = async (sku, getFullResponnse = true, locale) => {
  const config = {
    method: 'get',
    url: `/search/product/sku/${locale}`,
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    params: { sku },
  };
  if (!getFullResponnse) {
    config.url += `?${selectedAttributes}`;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductsBySkus = async ({ skuBulk, getFullResponnse = true }) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';

  const config = {
    method: 'get',
    url: '/search/product?' + transformSKus,
  };
  if (!getFullResponnse) {
    config.url += `&${selectedAttributes}`;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductsBySkusV2 = async (
  locale,
  skuBulk,
  getFullResponnse = true
) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/search/product/skus/${locale}?${transformSKus}`,
  };
  if (!getFullResponnse) {
    config.url += `&${selectedAttributes}`;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const submitQuestion = async (question, product_sku) => {
  const data = JSON.stringify({ question, product_sku, store_id: 1 });
  const config = {
    method: 'post',
    url: '/faqs/addFaq',
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const updatedSubmitQuestion = async (question, product_sku, customer_id) => {
  const data = JSON.stringify({
    question,
    product_sku,
    store_id: 1,
    customer_id,
  });
  const config = {
    method: 'post',
    url: '/faqs/addFaqQuestion',
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const submitAnswer = async (question_id, product_sku, answer, customer_id) => {
  const data = JSON.stringify({
    question_id,
    product_sku,
    answer,
    customer_id,
    store_id: 1,
  });
  const config = {
    method: 'post',
    url: '/faqs/addFaqAnswer',
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductFaqs = async (sku) => {
  const config = {
    method: 'get',
    url: `/faqs/getProductFaqs/${sku}/1`,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const notifyMe = async (entityId, userId) => {
  let config = {
    method: 'get',
    url: `/mstore/notify-out-of-stock-product/${userId}/${entityId}`,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const notifyMeV2 = async (entityId, userId, locale = 'ar') => {
  let config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/product-available/notify-me/${locale}/${userId}/${entityId}`,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAvailableStores = async (sku) => {
  const config = {
    method: 'get',
    url: `/mstore/store-locator/sku/${sku}`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAvailableStoresV2 = async (id, locale = 'ar') => {
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/store-locator/${locale}/product/${id}`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const rabahCreateAccount = async (data, mage) => {
  const config = {
    method: 'POST',
    url: '/rabah/create-account',
    data: JSON.stringify({ rabah: data }),
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductByUrl = async (url, locale, getFullResponnse = true) => {
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/product/by-innova-url/${url}/${locale}`,
  };
  if (!getFullResponnse) {
    config.url += `?${selectedAttributes}`;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getProductBySku,
  getProductsBySkus,
  submitQuestion,
  updatedSubmitQuestion,
  submitAnswer,
  getProductFaqs,
  notifyMe,
  getAvailableStores,
  rabahCreateAccount,
  getProductBySkuV2,
  getProductsBySkusV2,
  getAvailableStoresV2,
  notifyMeV2,
  getProductByUrl,
};
